export default "__VITE_ASSET__CIdbU8ct__"